<template>
  <el-menu
    class="header-bar-menu dock-right"
    mode="horizontal"
    background-color="#798896"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <el-menu-item index="3">
      <router-link to="/logout">
        <i class="el-icon-unlock"></i>
        <span>Logout</span>
      </router-link>
    </el-menu-item>

  </el-menu>
</template>

<script>
export default {
  data(){
    return {
      
    }
  }
}
</script>